import React from "react";

interface VideoBackgroundProps {
  video: string;
  altText: string;
  className: string | boolean;
}

const VideoBackground = ({ video, altText, className } : VideoBackgroundProps) => {

  return (
    <div className={`${className} video-background`}>
      <video 
        autoPlay 
        loop 
        muted 
        playsInline
        controls={false}
      >
        <source src={video} type="video/mp4"  />
        <meta itemProp="description" content={altText} />
      </video>
    </div>
  );
};

export default VideoBackground;
